import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import i18n from 'helpers/i18n';
import { getCurrentUserRole } from 'ducks/authentication';
import Template from 'components/Template/Template';
import Immutable from 'immutable';
import queryString from 'query-string';
import ContactForm from './ContactForm';
const styles = (theme) => {
  return {};
};
class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = { formComplete: false };
  }
  _getInitValues = () => {
    const uri = queryString.parse(window.location.search);
    // const $$initValues = uri.from && uri.from === 'rpps' ? Immutable.fromJS({
    //   subject: 'rpps'
    // }) : undefined;
    const $$initValues = undefined;
    return $$initValues;
  };
  _onContactFormComplete = () => {
    console.log('_onContactFormComplete');
    this.setState({ formComplete: true });
  };
  render() {
    const {
      // onPanelToggle,
      // classes,
      userRole,
    } = this.props;
    const { formComplete } = this.state;
    const uri = queryString.parse(window.location.search);
    const fromRPPS = uri.from && uri.from === 'rpps';
    const $$initValues = this._getInitValues();
    return (
      <Template
        userRole={userRole}
        page="contact"
        title={
          <Choose>
            <When condition={formComplete === true}>&nbsp;</When>
            <When condition={fromRPPS === true}>
              {i18n.get('contactFormRPPSTitle', {
                pretty: true,
              })}
            </When>
            <Otherwise>
              {i18n.get('contactFormTitle', {
                pretty: true,
              })}
            </Otherwise>
          </Choose>
        }
      >
        <ContactForm
          userRole={userRole}
          initValues={$$initValues}
          onContactFormComplete={this._onContactFormComplete}
        />
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    userRole: getCurrentUserRole(state),
  };
  return props;
}
export default withStyles(styles)(connect(mapStateToProps)(Contact));



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.jsx